@if (temIcones) {
  <div class="campo-segmentado-cards">
    @for (opcao of opcoes; track opcao.valor) {
      <button type="button" class="campo-segmentado-card" [class.campo-segmentado-card-ativo]="opcao.valor === valor"
              [disabled]="disabled || somenteLeitura" (click)="selecionar(opcao)">
        @if (opcao.icone) {
          <img [src]="opcao.icone" alt="" class="campo-segmentado-card-icone" />
        }
        <span class="campo-segmentado-card-label">{{ opcao.label }}</span>
        @if (opcao.valor === valor) {
          <img src="./assets/icones/redesign/utils/check-primary.svg" alt="" class="campo-segmentado-card-check" />
        }
      </button>
    }
  </div>
} @else if (somenteLeitura) {
  <span class="campo-valor-leitura">{{ opcaoAtual?.label || '--' }}</span>
} @else {
  <div class="campo-segmentado-container">
    <div class="campo-segmentado-indicador"
        [style.width]="'calc((100% - 6px) / ' + totalOpcoes + ')'"
        [style.transform]="'translateX(' + (indiceAtivo * 100) + '%)'"></div>
    @for (opcao of opcoes; track opcao.valor) {
      <button type="button" class="campo-segmentado-item" [class.campo-segmentado-item-ativo]="opcao.valor === valor"
              [disabled]="disabled" (click)="selecionar(opcao)">
        {{ opcao.label }}
      </button>
    }
  </div>
}
